import TransactionStatisticsProps from '../interfaces/TransactionStatisticsProps';
import useStatistics from '../hooks/useStatistics';
import FlexContainer from './FlexContainer';

const TransactionStatistics = ({
    setAction,
    date,
    transactions,
}: TransactionStatisticsProps) => {
    const { statistics } = useStatistics(transactions);

    return (
        <FlexContainer>
            <div>
                <h3 className="landing-container__text">
                    Showing details for:{' '}
                    <span className="green-span">{date}</span>
                </h3>
            </div>

            <div>
                <p className="transaction-box">
                    <span className="red-span">All Access Guests Signed In:</span>{' '}
                    {statistics?.allAccessGuests || 0}
                </p>
                <p className="transaction-box">
                    <span className="red-span">Limited Access Guests Signed In:</span>{' '}
                    {statistics?.limitedAccessGuests || 0}
                </p>

                <p className="transaction-box">
                    <span className="red-span">VIP Bands Sold:</span>{' '}
                    {statistics?.vipBandSold || 0}
                </p>
                <p className="transaction-box">
                    <span className="red-span">Jukebox Sold:</span>{' '}
                    {statistics?.jukeboxSold || 0}
                </p>
                <p className="transaction-box">
                    <span className="red-span">Waters Sold:</span>{' '}
                    {statistics?.waterSold || 0}
                </p>
                <p className="transaction-box">
                    <span className="red-span">Monsters Sold:</span>{' '}
                    {statistics?.monsterSold || 0}
                </p>
                <p className="transaction-box">
                    <span className="red-span">Red Bulls Sold:</span>{' '}
                    {statistics?.redBullSold || 0}
                </p>

                <p className="transaction-box">
                    <span className="red-span">All Access Fees Collected:</span>{' '}
                    {statistics?.allAccessFees || 0}$
                </p>
                <p className="transaction-box">
                    <span className="red-span">Limited Access Fees Collected:</span>{' '}
                    {statistics?.limitedAccessFees || 0}$
                </p>
                <p className="transaction-box">
                    <span className="guest-span-date">Total Fees:</span>{' '}
                    {statistics?.totalFees || 0}$
                </p>
            </div>

            <div>
                <button
                    className="red-button margin"
                    onClick={() =>
                        setAction({ status: false, type: 'statistics' })
                    }
                >
                    Go back
                </button>
            </div>
        </FlexContainer>
    );
};
export default TransactionStatistics;
